import React from 'react'

const AuthError = ({ error, onRetry }) => (
  <div className="container mt-5">
    <div className="row justify-content-center">
      <div className="col-md-6">
        <div className="alert alert-danger" role="alert">
          <div className="d-flex align-items-center mb-2">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            <strong>Authentication Error</strong>
          </div>
          <p className="mb-3">{error || 'An authentication error occurred.'}</p>
          {onRetry && (
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={onRetry}
            >
              Try Again
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
)

export default AuthError